import dateFormat from 'dateformat';
import { Box, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import { IndicatorDot } from 'components/dashboard/icons/indicator-dot';
import Image from 'next/image';
import { Timestamp } from 'firebase/firestore';
export interface SsiIndicatorProps {
  score?: number;
  isLoading?: boolean;
  updatedOn?: Timestamp | string;
}

export const SsiIndicator = ({
  score = 1,
  isLoading = false,
  updatedOn,
}: SsiIndicatorProps) => {
  const degree = 180 + (score / 100) * 180;

  const textLight = useColorModeValue(
    'text.lightMode.light',
    'text.darkMode.light'
  );

  let color = '#9AE299';
  if (score < 51) {
    color = '#EC6181';
  } else if (score < 66) {
    color = '#FFB992';
  } else if (score < 81) {
    color = '#FFE172';
  }

  let updatedOnDate: Date | null = null;

  if (updatedOn && typeof updatedOn === 'string') {
    updatedOnDate = new Date(updatedOn);
  } else if (updatedOn && updatedOn instanceof Timestamp) {
    updatedOnDate = updatedOn.toDate();
  }

  return (
    <Flex direction='column' align='center' pl='7px'>
      <Box
        sx={{
          position: 'relative',
          width: '272px',
          '--radius': '130px',
        }}
      >
        <Box
          sx={{
            marginLeft: '-7px',
          }}
        >
          <Image
            src='/assets/dashboard/range.png'
            alt='SSI Score Indicator'
            width={277}
            height={139}
          />
        </Box>
        {!isLoading && (
          <Box
            sx={{
              '--angle': `${degree}`,
              '--t': 'calc(var(--angle) * pi / 180)',
              position: 'absolute',
              left: 'calc((var(--radius)) * cos(var(--t)) + var(--radius)  )',
              top: 'calc((var(--radius)) * sin(var(--t)) + var(--radius)  )',
              width: '1px',
              height: '1px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: '5px',
              overflow: 'visible',
            }}
          >
            <Box>
              <IndicatorDot color={color} />
            </Box>
          </Box>
        )}
      </Box>
      {!isLoading && (
        <>
          <Text fontSize='7xl' mt='-80px' fontWeight='bold'>
            {Math.round(score)}
          </Text>
          <Text fontSize='lg'>Your SSI Score is</Text>
          {updatedOn && (
            <Text fontSize='xs' color={textLight}>
              Updated {dateFormat(updatedOnDate, 'mmm dd, yyyy')}
            </Text>
          )}
        </>
      )}
    </Flex>
  );
};
